import { Particle } from "../particle";
import { colorConstant, hold, lerp, parabolic, randomBetween } from "../interpolation";

/**
 * Small icy drops that drip/fall with gravity. Used as a continuous
 * indicator for temporarily frozen mobs. Same physics as BloodDripParticle
 * but with icy blue/cyan coloring.
 */
export class IceDripParticle extends Particle {
	/** Emission interval for generators (ms between particles). */
	static readonly emitIntervalMs = 200;

	constructor(originX: number, originY: number) {
		const ttl = randomBetween(300, 600);

		// Slight horizontal drift so drops don't stack vertically
		const vx = randomBetween(-0.3, 0.3);

		// Low initial downward speed — gravity does most of the work
		const vy = randomBetween(0.2, 0.6);

		const gravity = randomBetween(4, 6);

		const size = randomBetween(0.25, 0.4);

		// Icy blue/cyan coloring
		const r = randomBetween(100, 140);
		const g = randomBetween(180, 220);
		const b = randomBetween(230, 255);

		// Randomize spawn position around the cell so drops don't all come from center
		const ox = originX + randomBetween(-0.45, 0.45);
		const oy = originY + randomBetween(-0.45, 0.45);

		super(ox, oy, {
			ttl,
			size: lerp(size, size * 0.6),
			opacity: hold(1.0, 0.7, lerp(1.0, 0.0)),
			color: colorConstant(r, g, b),
			rotation: lerp(0, 0),
			position: parabolic(vx, vy, gravity),
		});
	}
}
